import { addContext, AdminContext, setContext } from '@acorns/admin-context'
import React, { useEffect } from 'react'
import { AuthContext } from './AuthContext'
import { useOktaAuth } from '@okta/okta-react'
import { oktaAuth } from '../../config/okta.config'
import { log } from '../../utils/log'

interface Props {
  children: React.ReactNode
}

export function AuthProvider({ children }: Props) {
  const { authState } = useOktaAuth()

  const accessToken = authState?.accessToken as any

  const id = accessToken?.claims?.uid
  const profile = accessToken?.claims?.profile
  const token = accessToken?.accessToken

  const adminUser = profile
    ? {
        id,
        firstName: profile?.given_name,
        lastName: profile?.family_name,
        displayName: profile?.name,
        email: profile?.email,
        roles: profile?.roles,
      }
    : null

  const signIn = () => {
    oktaAuth.signInWithRedirect().catch((err) => {
      log({ err })
    })
  }

  const signOut = () => {
    oktaAuth
      .signOut()
      .then(() => {
        setContext(null)
      })
      .catch((err) => {
        log({ err })
      })
  }

  useEffect(() => {
    if (adminUser && token) {
      addContext({
        adminUser,
        idToken: token,
        stage: process.env.BUILD_ENV,
      } as Partial<AdminContext>)
    }
  }, [adminUser, token])

  return (
    <AuthContext.Provider
      value={{
        signIn,
        signOut,
        adminUser,
      }}
    >
      {children}
    </AuthContext.Provider>
  )
}
